module.exports = __webpack_public_path__ + "static/media/arrow.c6e5dcd0.svg";